export const DEBUG_ROUTES_WITH_INLINE_MODALS = [
  '/dev/swap',
  '/dev/balances-modals',
  '/dev/modals',
  '/dev/vaults',
  '/dev/bankroll',
  '/dev/auth',
];
